import { refreshToken } from "../../application/actions/authActions";
import store from "../../application/store";
import {
  getAccessToken,
  getRefreshToken,
  isAccessTokenExpired,
  parseJwtPayload,
  readStoredUser,
} from "./authSession";

const CHECK_INTERVAL_MS = 2 * 60 * 1000;
const REFRESH_BEFORE_EXPIRY_MS = 10 * 60 * 1000;

const getAccessTokenExpiresAtMs = (user) => {
  const payload = parseJwtPayload(getAccessToken(user));
  if (!payload?.exp) {
    return null;
  }
  return payload.exp * 1000;
};

const shouldRefreshAccessToken = (user) => {
  if (!user || !getRefreshToken(user)) {
    return false;
  }

  if (!getAccessToken(user) || isAccessTokenExpired(user)) {
    return true;
  }

  const expiresAtMs = getAccessTokenExpiresAtMs(user);
  if (!expiresAtMs) {
    return false;
  }

  return expiresAtMs - Date.now() <= REFRESH_BEFORE_EXPIRY_MS;
};

let keepAliveTimerId = null;
let refreshInFlight = false;

export const startAuthTokenKeepAlive = () => {
  if (keepAliveTimerId != null) {
    return;
  }

  const tick = async () => {
    const user = readStoredUser();
    if (!shouldRefreshAccessToken(user)) {
      return;
    }

    if (refreshInFlight) {
      return;
    }

    refreshInFlight = true;
    try {
      await store.dispatch(refreshToken()).unwrap();
    } catch {
      // axios interceptor / auth slice handle logout when refresh is invalid
    } finally {
      refreshInFlight = false;
    }
  };

  tick();
  keepAliveTimerId = window.setInterval(tick, CHECK_INTERVAL_MS);
};

export const stopAuthTokenKeepAlive = () => {
  if (keepAliveTimerId != null) {
    window.clearInterval(keepAliveTimerId);
    keepAliveTimerId = null;
  }
  refreshInFlight = false;
};
